import LandingPageLayout from 'components/LandingPageLayout';
import TitleSectionThree from 'components/LandingPageTitleSection/TitleSectionThree';
import NewWelcome from 'components/v1-tailwindcss/NewWelcome';
import WhyUs from 'components/LandingPageWhyUs';
import Blogs from 'components/LandingPageBlogs';
import React from 'react';
import BenifitsV1 from 'components/v1-tailwindcss/BenifitsV1';
import Head from 'next/head';


const ForRenters = () => {
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>For Renters</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/for-renters" />
        <meta
          name="description"
          content="Find and book rooms
            and entire apartments/condos/
            houses for rent."
        />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Rent Conveniently from Hundreds of Landlords" />
        <meta
          property="og:description"
          content="Find and book rooms
            and entire apartments/condos/
            houses for rent."
        />

        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Find and book rooms
            and entire apartments/condos/
            houses for rent."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <link rel="canonical" href="https://www.soulrooms.com/for-renters" />
         
      </Head>
      <LandingPageLayout>
        {/* oldcomponent welcome */}
        <NewWelcome
          href="/find-a-soulroom"
          hello="Hello"
          title="WELCOME TO SOULROOMS"
          discription="SoulRooms enable modern renters to discover, inquire and book great places to stay across the city. #Rentingfordigitalnatives"
        />

        {/*  WHETHER YOU’RE MOVING WITH FRIENDS OR FLYING SOLO, WE’VE GOT*/}

        {/* old WhyUs component  */}
        {/* <WhyUsV1
          head="WHETHER YOU’RE MOVING WITH FRIENDS OR FLYING SOLO, WE’VE GOT YOU COVERED"
          imghead1="Properties by the Room"
          imgdiscrip1="Rent out private rooms directly from landlords and be matched with housemates using our Artificial Intelligence tool"
          imghead2="Entire Units"
          imgdiscrip2="Amazing studios, 1-bed units within your budget from the best landlords in the city"
          imghead3="Student Residences"
          imgdiscrip3="Great multi-bed houses near universities fit right into your student budget and are carefully designed by savvy landlords."
        /> */}
        <WhyUs
            bg="none"
            title="WHETHER YOU’RE MOVING WITH FRIENDS OR FLYING SOLO, WE’VE GOT YOU COVERED"
            heading1="Properties by the Room"
            detail1="Rent out private rooms directly from landlords and be matched with housemates using our Artificial Intelligence tool"
            heading2="Entire Units"
            detail2="Amazing studios, 1-bed units within your budget from the best landlords in the city"
            heading3="Student Residences"
            detail3="Great multi-bed houses near universities fit right into your student budget and are carefully designed by savvy landlords."
            img1="/static/images/landingPages/ForRenters/room.png"
            img2="/static/images/landingPages/ForRenters/units.png"
            img3="/static/images/landingPages/ForRenters/studentresident.png"
          />
        <TitleSectionThree bg={false} title="INTERESTED TO CHECK OUT YOUR OPTIONS?" btnTxt="Find Properties" href="/find-a-soulroom" />


        {/* Title Section Missing */}

        {/* old components BENEFITS  */}

        <BenifitsV1 />
        <TitleSectionThree bg={false} title="LOOKING FOR A PLACE TO STAY?" btnTxt="Find Properties" href="https://www.realsage.com/properties" />


        {/* Title Section Missing */}

        {/*old component BLOG SECTION  */}
        <Blogs residentBlog={true} />

        {/* <BlogsV1 head1="RESIDENT'S BLOG" /> */}
      </LandingPageLayout>
    </>
  );
};

export default ForRenters;
